module.exports = __webpack_public_path__ + "img/leaderboard-crown.d1fd4998.svg";